import React from "react";

export default function TOSMap() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="580" height="580" viewBox="0 0 580 580">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#288CFF"
          d="M241.33 4.09a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4M145.63 51.93a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4M97.78 99.78a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4M97.78 147.63a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m95.7 0a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m95.7 0a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4M49.93 147.63a2 2 0 100-4 2 2 0 000 4m47.85 47.85a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m287.09 0a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4M49.93 195.48a2 2 0 100-4 2 2 0 000 4m47.85 47.85a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m287.09 0a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m-478.49 95.7a2 2 0 100-4 2 2 0 000 4m47.85 47.85a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m287.09 0a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4M2.09 243.33a2 2 0 100-4 2 2 0 000 4m47.84 47.85a2 2 0 100-4 2 2 0 000 4m47.85 47.84a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m287.09 0a2 2 0 100-4 2 2 0 000 4m47.85-47.84a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4M2.09 291.18a2 2 0 100-4 2 2 0 000 4m47.84 47.84a2 2 0 100-4 2 2 0 000 4m47.85 47.85a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m287.09 0a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m47.85-47.84a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4M2.09 339.02a2 2 0 100-4 2 2 0 000 4m47.84 47.85a2 2 0 100-4 2 2 0 000 4m47.85 47.85a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m-526.33 95.7a2 2 0 100-4 2 2 0 000 4m47.85 47.85a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4M145.63 530.42a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4m47.85-47.85a2 2 0 100-4 2 2 0 000 4M241.33 578.26a2 2 0 100-4 2 2 0 000 4m47.84 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4M194.33 195.48a2 2 0 100-4 2 2 0 000 4m46.14-.86a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#FFF" d="M288.32 194.62a2 2 0 100-4 2 2 0 000 4"></path>
        <path
          fill="#288CFF"
          d="M336.17 194.62a2 2 0 100-4 2 2 0 000 4m49.56.86a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#FFF" d="M192.62 242.47a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#288CFF" d="M240.47 242.47a2 2 0 100-4 2 2 0 000 4"></path>
        <g strokeWidth="1.71" transform="translate(264.87 217.03)">
          <circle cx="24.78" cy="24.78" r="24.78" stroke="#FFF"></circle>
          <path stroke="#FFF" d="M20.52 21.86l8.43-4.49"></path>
          <path stroke="#288CFF" d="M16.5 19.79l8.27 4.13 8.28-4.13m-8.28 14.18V23.92"></path>
          <path
            stroke="#288CFF"
            d="M25.53 15.76l6.84 3.42.95.49v10.21l-.95.5-6.84 3.42-.76.38-.76-.38-6.84-3.42-.94-.5V19.67l.95-.49 6.83-3.42.76-.38z"></path>
        </g>
        <g strokeWidth="1.71" transform="translate(312.72 360.57)">
          <circle cx="24.78" cy="24.78" r="24.78" stroke="#288CFF"></circle>
          <path stroke="#FFF" d="M20.52 21.86l8.43-4.49"></path>
          <path stroke="#288CFF" d="M16.5 19.79l8.27 4.13 8.28-4.13m-8.28 14.18V23.92"></path>
          <path
            stroke="#288CFF"
            d="M25.53 15.76l6.84 3.42.95.49v10.21l-.95.5-6.84 3.42-.76.38-.76-.38-6.84-3.42-.94-.5V19.67l.95-.49 6.83-3.42.76-.38z"></path>
        </g>
        <g strokeWidth="1.71" transform="translate(361.42 121.33)">
          <circle cx="24.78" cy="24.78" r="24.78" stroke="#288CFF"></circle>
          <path
            stroke="#288CFF"
            d="M28.35 29.61l-.02 3.01.02 1.56h-7.13V29.6m0-9.7v-4.53h7.13v1.55l-.02 2.98"></path>
          <path stroke="#FFF" d="M29 20.55A5.98 5.98 0 1120.56 29 5.98 5.98 0 0129 20.55"></path>
          <path stroke="#FFF" d="M24.78 21.4v3.38l1.66 1.71"></path>
        </g>
        <g strokeWidth="1.71" transform="translate(170.03 120.47)">
          <circle cx="24.78" cy="24.78" r="24.78" stroke="#288CFF"></circle>
          <path
            stroke="#288CFF"
            d="M32.47 23.07c0 5.98-7.7 11.1-7.7 11.1s-7.68-5.12-7.68-11.1h0a7.69 7.69 0 0115.38 0s0 0 0 0h0z"></path>
          <path
            stroke="#FFF"
            d="M26.6 21.26a2.56 2.56 0 11-3.63 3.62 2.56 2.56 0 013.62-3.62"></path>
        </g>
        <path fill="#288CFF" d="M336.17 242.47a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#FFF" d="M384.02 242.47a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#288CFF" d="M192.62 290.32a2 2 0 100-4 2 2 0 000 4"></path>
        <g transform="translate(169.18 312.72)">
          <circle
            cx="24.78"
            cy="24.78"
            r="24.78"
            fill="#000F1F"
            stroke="#288CFF"
            strokeWidth="1.71"></circle>
          <g transform="translate(7.69 17.09)">
            <circle cx="10.25" cy="15.38" r="1.71" fill="#288CFF"></circle>
            <circle cx="16.23" cy="15.38" r="1.71" fill="#288CFF"></circle>
            <circle cx="4.27" cy="15.38" r="1.71" fill="#288CFF"></circle>
            <circle cx="29.05" cy="15.38" r="1.71" fill="#288CFF"></circle>
            <path
              stroke="#288CFF"
              strokeWidth="1.71"
              d="M23.92 8.54V0h6.84l3.42 4.27v6.84H0"></path>
            <path stroke="#FFF" strokeWidth="1.71" d="M21.36 0H.85v8.54"></path>
          </g>
        </g>
        <g transform="translate(409.27 264.02)">
          <circle
            cx="24.78"
            cy="24.78"
            r="24.78"
            fill="#000F1F"
            stroke="#288CFF"
            strokeWidth="1.71"></circle>
          <g transform="translate(7.69 17.09)">
            <circle cx="10.25" cy="15.38" r="1.71" fill="#288CFF"></circle>
            <circle cx="16.23" cy="15.38" r="1.71" fill="#288CFF"></circle>
            <circle cx="4.27" cy="15.38" r="1.71" fill="#288CFF"></circle>
            <circle cx="29.05" cy="15.38" r="1.71" fill="#288CFF"></circle>
            <path
              stroke="#288CFF"
              strokeWidth="1.71"
              d="M23.92 8.54V0h6.84l3.42 4.27v6.84H0"></path>
            <path stroke="#FFF" strokeWidth="1.71" d="M21.36 0H.85v8.54"></path>
          </g>
        </g>
        <path fill="#288CFF" d="M240.47 290.32a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#FFF" d="M288.32 290.32a2 2 0 100-4 2 2 0 000 4"></path>
        <path
          fill="#288CFF"
          d="M336.17 290.32a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m-143.55 47.85a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4m47.85 0a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#FFF" d="M384.02 338.17a2 2 0 100-4 2 2 0 000 4"></path>
        <path
          fill="#288CFF"
          d="M194.33 386.87a2 2 0 100-4 2 2 0 000 4m46.14-.85a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#FFF" d="M288.32 386.02a2 2 0 100-4 2 2 0 000 4"></path>
        <path fill="#288CFF" d="M386.72 388.85a2.99 2.99 0 100-5.98 2.99 2.99 0 000 5.98"></path>
      </g>
    </svg>
  );
}
